import {Dialog, styled} from "@mui/material";

const ModalDialog = styled(Dialog)(({ theme }) => ({
    '.MuiDialog-container > .MuiPaper-root': {
        borderRadius: '10px',
        width: '100%',
        background: 'rgba(36, 44, 55,0.95)',
        padding: '0px 0px 0px',
        border: '1px solid #5E6980',
        boxShadow:
            '0px 2.1574831008911133px 29.22142219543457px 0px rgba(0, 0, 0, 0.05), 0px 3.806384325027466px 39.8596076965332px 0px rgba(0, 0, 0, 0.07), 0px 5.703558921813965px 44.46048355102539px 0px rgba(0, 0, 0, 0.08), 0px 10.160801887512207px 47.2956428527832px 0px rgba(0, 0, 0, 0.09), 0px 25.993473052978516px 52.371063232421875px 0px rgba(0, 0, 0, 0.10), 0px 100px 77px 0px rgba(0, 0, 0, 0.13)',

        [theme.breakpoints.up('xs')]: {
            padding: '35px 15px 10px',
            margin: '24px',
            maxWidth: '320px'
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '800px'
        },
    },
}));

export default ModalDialog;